<template>
    <v-select
        :items="providers"
        v-model="providers[0]"
        label="Provider *"
        item-text="name"
        item-value="name"
        dense
        outlined
        :clearable="false"
        disabled
    />
</template>

<script>
export default {
    data() {
        return {
            providers: [ "Vodafone" ],
        };
    },
};
</script>